import React from "react";
import styled from "styled-components";

export default ({ items }) => (
  <Wrap className="flex">
    {items.map((item, i) => <Item key={i}>{item}</Item>)}
  </Wrap>
);

const Wrap = styled.div`
  display: flex;
  padding: 1rem 0;
`;

const Item = styled.div`
  border-radius: 100px;
  margin-right: 0.5rem;
  padding: 0.325rem 1.25rem;
  background-color: #fff;
  font-family: "CircularStd-Book", sans-serif;
  font-size: 0.9rem;
`;



// WEBPACK FOOTER //
// ./src/components/common/candidate/ScheduleCall/components/Tags/index.js